<div *ngIf="resultSetConfig" class="toggle-button-container">
  <mat-slide-toggle
    [id]="'result-set-as-default-toggle' + resultSetConfig.resultSetID"
    [name]="'result-set-as-default-toggle' + resultSetConfig.resultSetID"
    [(ngModel)]="resultSetConfig.dropdownConfigEnabled"
    (ngModelChange)="onToggleChange()"
  >{{'RESULTS.RESULT_CONFIG.SET_AS_DEFAULT' | anessaTranslation: translationTrigger}}</mat-slide-toggle>
</div>
